import type { VisionWidget } from '@/components/VisionAi/widgets/visionWidget.types';

interface UnifiedToolRun {
  ui?: { widgets?: VisionWidget[] };
}

export function parseUnifiedWidgets(
  additionalContent: Record<string, unknown> | null | undefined,
): VisionWidget[] {
  if (!additionalContent) return [];

  const widgets: VisionWidget[] = [];
  Object.values(additionalContent).forEach((toolRuns) => {
    if (!Array.isArray(toolRuns)) return;

    (toolRuns as UnifiedToolRun[]).forEach((toolRun) => {
      const uiWidgets = toolRun?.ui?.widgets;
      if (Array.isArray(uiWidgets)) {
        widgets.push(...uiWidgets);
      }
    });
  });

  return widgets;
}
